import React, { ReactElement } from "react";
import { Column } from "../../../../components/BaseTable";
import {
  GebeurtenissenTabelData,
  GebeurtenisRijData,
} from "../../../../../../.generated/rapportage/rapportagetypes";
import Table from "../../../../components/Table";

export const GebeurtenissenTabel = ({
  data,
}: {
  data: GebeurtenissenTabelData;
}): ReactElement => {
  const columns: Column<GebeurtenisRijData>[] = [
    {
      header: "Jaar",
      accessor: "jaar",
    },
    {
      header: "Hypotheekschuld",
      accessor: "hypotheekSchuld",
      dataType: "currency",
    },
    {
      header: "Fiscaal aftrekbaar",
      accessor: "fiscaalAftrekbaar",
      dataType: "currency",
    },
    {
      header: "Bruto maandlast",
      accessor: "brutoMaandlast",
      dataType: "currency",
    },
    {
      header: "Netto maandlast",
      accessor: "nettoMaandlast",
      dataType: "currency",
    },
    {
      header: "Bijzonderheden",
      accessor: "bijzonderheden",
    },
  ];

  return (
    <Table
      data={data.rijen ?? /*istanbul ignore next*/ []}
      columns={columns}
      id="gebeurtenissen-table"
    />
  );
};
